<div class="flex h-full w-full flex-col">
  @if (newPlanModalIsOpen()) {
    <app-modal
      [config]="newPlanningSpaceModalConfig()"
      [size]="ModalSize.MD"
      (closeModal)="newPlanModalIsOpen.set(false)"
      [title]="newPlanningSapceModalTitle()">
      <app-new-planning-space
        #newPlanningSpaceComponent
        modal-body
        [config]="newPlanningSpaceConfig()"
        [submissionErrorSource]="newPlanSubmissionError()"
        (closeModal)="newPlanModalIsOpen.set(false)"
        (newPlanningSpaceOutput)="submitNewPlanningSpace($event)" />
    </app-modal>
  }
  @if (deletePlanningSpaceModal().isOpen) {
    <app-modal
      [config]="deletePlanningSpaceModal().config"
      (closeModal)="deletePlanningSpaceModal().isOpen = false"
      [title]="deletePlanningSpaceModal().title()">
      <div modal-body class="my-4">{{ deletePlanningSpaceModal().message() }}</div>
    </app-modal>
  }
  @if (updatePlanModalIsOpen()) {
    <app-modal
      [config]="updatePlanningSpaceModalConfig"
      (closeModal)="updatePlanModalIsOpen.set(false)"
      [title]="updatePlanningSapceModalTitle()">
      <app-update-planning-space
        modal-body
        [config]="updatePlanningSpaceConfig()"
        (closeModal)="updatePlanModalIsOpen.set(false)"
        (updatePlanningSpaceOutput)="submitUpdatePlanningSpace($event)" />
    </app-modal>
  }

  <app-toolbox
    [sections]="toolboxSections()"
    [paginationConfig]="paginationConfig()"
    [searchConfig]="searchCfg"
    [showSelect]="showSelect()"
    [showPageSelector]="showPageSelector()"
    [selectedItemsCount]="onSelect()"
    [displayedItemCount]="planningSpaces().length"
    [totalItems]="pagination.totalItems()"
    [searchPlaceholder]="searchPlaceholder()"
    [useAdvancedFiltering]="true"
    [(showAdvancedFiltering)]="showAdvancedFiltering"
    (deselectAll)="clearSelection()"
    (pageChange)="onPageChange($event)"
    (selectOnly)="onSelectOnly($event)"
    (searchQueryChange)="OnSearchTermChange($event)" />

  @if (showAdvancedFiltering()) {
    <app-filter-query-builder
      [availableFields]="availableAdvancedFilters()"
      [initialConfiguration]="advancedFilters()"
      [openFilterForField]="openFilterForField()"
      (filterChange)="onFilterChanges($event)">
      <app-filter-presets filter-presets />
    </app-filter-query-builder>
  }

  <div class="flex h-full min-h-0 flex-1 flex-col">
    <as-split
      direction="vertical"
      unit="percent"
      class="h-full w-full"
      [useTransition]="true">
      <as-split-area [visible]="true">
        <app-table
          [tableId]="'planning-space-list'"
          [data]="planningSpaces()"
          [allColumns]="columns()"
          [actions]="actions()"
          [config]="tableConfig()"
          [selected]="selectedItems()"
          [initialSort]="presetSort()"
          (addFilterOn)="addFilterOn($event)"
          (removeFilterOn)="removeFilterOn($event)"
          (sortChange)="onSortChange($event)"
          class="rounded-sm" />
      </as-split-area>
      <as-split-area [visible]="compareOpen()">
        <app-kpi-comparison
          class="border-default flex h-full w-full flex-col overflow-hidden rounded-sm border"
          [items]="compareItems()"
          [decimals]="kpiDecimals()"
          [kpiOrder]="kpiOrder()"
          (closed)="compareOpen.set(false)"
          (choiceChange)="onCompareChoice($event)" />
      </as-split-area>
    </as-split>
  </div>
</div>
